import styled from "@emotion/styled";
import { Box } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { fonts } from "styles/AtomicStyles";

import { ImageIcons } from "components";

export const ProductImage = styled(ImageIcons)`
  height: 66px;
  width: 66px;
`;

export const PreviousBuys = styled.div(({ islastcard }) => ({
  margin: "0 1rem",
  marginBottom: islastcard === "true" ? "4rem" : "2rem",
  minWidth: "90%",
  maxWidth: "100%",
}));

export const PurchaseCardWrapper = styled.div(({ colors }) => ({
  background: colors.lightGray,
  borderRadius: "12px",
  border: "2px solid #eeeeee",
}));

export const EmptyStateContainer = styled.div`
  margin-top: 0.5rem;
  padding: 0 1rem;
`;

export const EmptyStateBox = styled(Box)`
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.06);
  padding: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
`;

export const PrevAuctionsContainer = styled.div`
  padding-bottom: 5rem;
  margin-top: 1rem;
`;

export const EmptyStateTitle = styled.div`
  font-size: 16px;
  text-transform: lowercase;
  margin-bottom: 8px;
  color: black;
  font-weight: 700;
`;

export const EmptyStateDescription = styled.span`
  display: flex;
  align-items: center;
`;

export const styles = makeStyles(({ colors }) => ({
  mandiName: {
    background: `${colors.mustardYellow} !important`,
    padding: "0.25rem 0.5rem",
    borderRadius: "0.375rem",
  },
  dashboardWrapper: {
    padding: "0 1rem",
    marginTop: "7.5rem",
    backgroundColor: colors.smokeWhite,
    height: "100%",
    display: "flex",
    flexDirection: "column",
    font: fonts.NOTO_SANS,
  },
  layoutWrapper: {
    fontFamily: fonts.NOTO_SANS,
    position: "absolute",
    top: "10rem",
    marginLeft: "0.8rem",
    fontSize: "14px",
  },
  viewAll: {
    marginTop: "2rem",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    bottom: "0",
    right: "0",
  },
}));
